import { styled } from '@mui/system';
import React from 'react';

const MainStyled = styled('main')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    borderRadius: '4px',
    boxShadow: '0 2px 7px 0 rgba(0, 0, 0, 0.11)',
}));
export function AppTabsPanelContainer({ children, reduceHeightBy = 0 }) {
    const applyTabsPanelContainerHeight = () => {
        const appBannerHeight = document.querySelector('.App-bannerContainer')?.clientHeight || 0;
        const $appTabsPanelContainer = document.querySelector('.App-tabsPanel-container');

        const $appWrap = document.querySelector('.App-wrap');
        let appWrapMarginTop = '';
        if ($appWrap) {
            appWrapMarginTop = window.getComputedStyle($appWrap).marginTop;
        }
        appWrapMarginTop = appWrapMarginTop.replace('px', '').replace('-', '');

        const spaceToKeepFromBottom = 60;

        const heightToSubtract = appBannerHeight - parseInt(appWrapMarginTop, 10) + spaceToKeepFromBottom;

        $appTabsPanelContainer?.style.setProperty('height', `calc(100vh - ${heightToSubtract + reduceHeightBy}px)`);
    };

    React.useEffect(() => {
        applyTabsPanelContainerHeight();
        // on resize
        window.addEventListener('resize', applyTabsPanelContainerHeight);
    }, []);

    return <MainStyled className="App-tabsPanel-container">{children}</MainStyled>;
}
